import React, {Fragment} from 'react';

import {OdontoDistricts} from './components/OdontoDistricts';
import {DistrictSelectionProps} from './types';
import {FlowEnum} from '../../constants';
import {HealthDistricts} from './components/HealthDistricts';
import {ExamsDistricts} from './components/ExamsDistricts';

export function DistrictSelection({
	flowType,
	handlePrevStep,
	handleNextStep,
}: DistrictSelectionProps) {
	const isOdontoFlow = flowType === FlowEnum.ODONTO;
	const isHealthFlow = flowType === FlowEnum.HEALTH;
	const isExamFlow = flowType === FlowEnum.EXAM;

	return (
		<Fragment>
			{isOdontoFlow ? (
				<OdontoDistricts handlePrevStep={handlePrevStep} handleNextStep={handleNextStep} />
			) : null}
			{isHealthFlow ? (
				<HealthDistricts handlePrevStep={handlePrevStep} handleNextStep={handleNextStep} />
			) : null}
			{isExamFlow ? (
				<ExamsDistricts handlePrevStep={handlePrevStep} handleNextStep={handleNextStep} />
			) : null}
		</Fragment>
	);
}
